const getImageCropSettings = cropSettings => cropSettings?.map(crop => {
  const cropType = (crop.type || crop.name);

  return {
    type: cropType,
    ...(cropType === 'free' ? {} : { height: crop.height, width: crop.width }),
  };
});

export default getImageCropSettings;
